/**
 * HIRA (Hazard Identification and Risk Assessment) Constants
 * Centralized constants for HIRA module to ensure consistency across the application
 */

/**
 * Assessment Type Descriptions
 * Provides detailed explanations for each HIRA assessment type to help users
 * understand which type to use for their specific needs
 */
export const ASSESSMENT_TYPE_DESCRIPTIONS = {
  "General":
    "General Assessment HIRA (Macro View): Covers the entire workplace including all departments, areas, and facilities. Used for organization-wide risk profiling and long-term safety planning.",

  "Activity-based":
    "Activity-based HIRA (Operational View): Focuses on a specific activity or operational phase such as construction, warehousing, or maintenance. Used to identify and control hazards across a broad work scope.",

  "Task-based":
    "Task-based HIRA / TBRA (Focused View): Used for high-risk or non-routine tasks just before execution. Ensures task-specific hazards are identified and controls are in place for dynamic work conditions.",

  "JSA":
    "Job Safety Analysis (Micro View): Breaks a job into individual physical steps and identifies hazards and controls for each step. Primarily used to define safe work procedures for frontline workers."
};

/**
 * Assessment Types
 * Available assessment types for HIRA
 */
export const ASSESSMENT_TYPES = {
  GENERAL: "General",
  ACTIVITY_BASED: "Activity-based",
  TASK_BASED: "Task-based",
  JSA: "JSA"
};

/**
 * Risk Levels
 * Standard risk level classifications for 5x5 matrix
 */
export const RISK_LEVELS = {
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  CRITICAL: "Critical"
};

/**
 * Control Types (Hierarchy of Controls)
 * From most effective to least effective
 */
export const CONTROL_TYPES = {
  ELIMINATION: "Elimination",
  SUBSTITUTION: "Substitution",
  ENGINEERING: "Engineering",
  ADMINISTRATIVE: "Administrative",
  PPE: "PPE"
};

export default {
  ASSESSMENT_TYPE_DESCRIPTIONS,
  ASSESSMENT_TYPES,
  RISK_LEVELS,
  CONTROL_TYPES
};
